import { Obj } from "@kizmann/pico-js";

export const LoginFormConfig = {};

Obj.set(LoginFormConfig, 'NFormItem:codehash', {
    props: {
        label: '@Code',
        prop: 'codehash',
    },
});

Obj.set(LoginFormConfig, 'NFormItem:codehash.content.NInput', {
    binds: {
        modelValue: {
            value: '$model.codehash', fallback: ''
        }
    },
    props: {
        disabled: true, placeholder: '@No login yet'
    }
});

Obj.set(LoginFormConfig, 'NFormItem:email', {
    props: {
        label: '@Email',
        prop: 'email',
        rules: ['required', 'email']
    },
});

Obj.set(LoginFormConfig, 'NFormItem:email.content.NInput', {
    binds: {
        modelValue: {
            value: '$model.email', fallback: ''
        }
    },
    props: {
        placeholder: '@Email'
    }
});

Obj.set(LoginFormConfig, 'NFormItem:is_super', {
    vIf: function() {
        return !! Obj.get(this.$root, 'user.is_super');
    },
    props: {
        label: '@Super',
        prop: 'is_super',
    },
});

Obj.set(LoginFormConfig, 'NFormItem:is_super.content.NSwitch', {
    binds: {
        modelValue: {
            value: '$model.is_super', fallback: 0
        }
    },
    props: {
        onValue: 1,
        offValue: 0
    },
    content: '@User is super',
});

Obj.set(LoginFormConfig, 'NFormItem:password_new', {
    props: {
        label: '@Password',
        prop: 'password_new',
        rules: ['minlength:10']
    },
});

Obj.set(LoginFormConfig, 'NFormItem:password_new.content.NInput', {
    binds: {
        modelValue: {
            value: '$model.password_new', fallback: ''
        }
    },
    props: {
        placeholder: '@Fill to set new password'
    }
});

Obj.set(LoginFormConfig, 'NFormItem:password_dup', {
    props: {
        label: '@Password confirm',
        prop: 'password_dup',
        rules: ['same:password_new']
    },
});

Obj.set(LoginFormConfig, 'NFormItem:password_dup.content.NInput', {
    binds: {
        modelValue: {
            value: '$model.password_dup', fallback: ''
        }
    },
    props: {
        placeholder: '@Fill to set new password'
    }
});



export default LoginFormConfig;